import React, { useEffect, useState } from "react";
import axios from "axios";
import { useForm } from "react-hook-form";
import toastr from "../../../utils/toast";

function AddMediaModal({ show, onClose, roleId, token, refreshFiles }) {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const [documentTypes, setDocumentTypes] = useState([]);

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm();

  useEffect(() => {
    if (show) {
      axios
        .get(`${API_BASE_URL}/roles/documenttypes`, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((res) => setDocumentTypes(res.data.documentTypes))
        .catch((err) => console.error("Error fetching document types:", err));
    }
  }, [show, API_BASE_URL, token]);

  const onSubmit = async (data) => {
    try {
      // Step 1: Upload file
      const formData = new FormData();
      formData.append("file", data.file[0]);

      const uploadRes = await axios.post(
        `${API_BASE_URL}/roles/upload_file/upload`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      const savename = uploadRes.data.savename;
      if (!savename) throw new Error("Upload failed");

      // Step 2: Save file metadata
      const user_id = 1; // Replace with actual user ID
      const dbSaveRes = await axios.post(
        `${API_BASE_URL}/roles/upload_file`,
        {
          role_id: roleId,
          documenttype_id: data.documentTypeId,
          name: data.name,
          savename,
          user_id,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (dbSaveRes.status === 201) {
        toastr.success("File added successfully!");
        refreshFiles();
        reset(); // Clear form
        onClose();
      } else {
        toastr.error("Failed to save file metadata");
      }
    } catch (err) {
      console.error("Error:", err);
      toastr.error("Something went wrong");
    }
  };

  if (!show) return null;

  return (
    <div className="modal show d-block" tabIndex="-1">
      <div className="modal-dialog">
        <form className="modal-content" onSubmit={handleSubmit(onSubmit)}>
          <div className="modal-header">
            <h5 className="modal-title">Add Media</h5>
            <button
              type="button"
              className="btn-close"
              onClick={onClose}
            ></button>
          </div>
          <div className="modal-body">
            {/* Name */}
            <div className="mb-3">
              <label className="form-label">Name *</label>
              <input
                className={`form-control ${errors.name ? "is-invalid" : ""}`}
                {...register("name", { required: "Name is required" })}
              />
              {errors.name && (
                <div className="invalid-feedback">{errors.name.message}</div>
              )}
            </div>

            {/* Description */}
            <div className="mb-3">
              <label className="form-label">Description</label>
              <input
                className={`form-control ${errors.name ? "is-invalid" : ""}`}
                {...register("description", {
                  required: "Description is required",
                })}
              />
            </div>

            {/* Document Type */}
            <div className="mb-3">
              <label className="form-label">Document Type *</label>
              <select
                className={`form-select ${
                  errors.documentTypeId ? "is-invalid" : ""
                }`}
                {...register("documentTypeId", {
                  required: "Document type is required",
                })}
              >
                <option value="">Select...</option>
                {documentTypes.map((dt) => (
                  <option key={dt.id} value={dt.id}>
                    {dt.name}
                  </option>
                ))}
              </select>
              {errors.documentTypeId && (
                <div className="invalid-feedback">
                  {errors.documentTypeId.message}
                </div>
              )}
            </div>

            {/* File */}
            <div className="mb-3">
              <label className="form-label">File *</label>
              <input
                type="file"
                className={`form-control ${errors.file ? "is-invalid" : ""}`}
                {...register("file", { required: "File is required" })}
              />
              {errors.file && (
                <div className="invalid-feedback">{errors.file.message}</div>
              )}
            </div>
          </div>

          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={onClose}
            >
              Close
            </button>
            <button type="submit" className="btn btn-primary">
              Save
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default AddMediaModal;
